// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"4e1b7149","251":"036db7f8","270":"68410f57","415":"3c1d9139","628":"7b735fe4","694":"7700df10","959":"73b8eac4"}[chunkId] + ".chunk.js";
};